import React, { useState, useEffect } from "react";
import BalanceCard from "./BalanceCard";
import RecentTCard from "./RecentTCard";
import { ethers } from "ethers";
import { SiBitcoinsv } from "react-icons/si";
import { SiEthereum } from "react-icons/si";
import { MdMonetizationOn } from "react-icons/md";
import { SiBinance } from "react-icons/si";
import { FaJediOrder } from "react-icons/fa";
import { useNetwork, useSwitchNetwork, useSigner, useAccount } from "wagmi";
import Navbar from "../Components/Navbar";

import dateFormat from "dateformat";
import { getWallwtChainBalance } from "../Services/Moralis";
import { getTansactionByWallet } from "../Services/Moralis";
import { TokenBalancebyWallet } from "../Services/Moralis";
import {getUsdBalance} from "../Services/CryptoCompare"
import Spinner from "../Components/Spinner";

import useWeb3 from "web3";

import axios from "axios";

import Marquee from "../Accounts/Marquee";
import { sepolia, useConnect } from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";

const Dashboard = () => {
  const [sepoliabalance, setSepoliabalance] = useState();
  const [etherBalance, setEtherBalance] = useState();
  const [bscBalance, setBscBalance] = useState();
  const [account, setAccount] = useState();
  const [totalBalance, setTotalBalance] = useState();
  const [allTransaction, setallTransaction] = useState([]);
  const [currentChain, setCurrentChain] = useState();
  const [ercTokenBalance, setercTokenBalance] = useState();
  const [loading, setLoading] = useState(true);
  const [pricing,setPricing] = useState([]);
  const [balanceloading,setbalanceLoading] = useState(true)

  //-------------wagmi-Hooks----------------------//
  const { chain } = useNetwork();
  const { data: signer } = useSigner();
  const { connector: activeConnector, isConnected } = useAccount();

  useEffect(() => {
    if (signer && isConnected) {
    getUsdBalance().then((_res)=>{
      setPricing(_res);
      setbalanceLoading(false)
    })
     

      if (chain.id === 97) {
        //console.log("chain id  97 event called i=on chain changed");
        setCurrentChain("bsc%20testnet");
        getAddress().then(async (_address) => {
          getTansactionByWallet("bsc%20testnet", _address).then((_response) => {
           
            setallTransaction(_response);
            setLoading(false);
          });
        });

        getAddress().then(async (_response) => {
          //---BEP------//
          TokenBalancebyWallet(
            "bsc%20testnet",
            _response,
            "0x8083f306F987fd6965b1Cec9EaFc4e7Ac64B6c5c"
          ).then((_bepBalance) => {
           
            setercTokenBalance(_bepBalance);
          });
        });
      } else {
       // console.log("chain id  11155111 event called i=on chain changed");
        setCurrentChain("sepolia");
        
        getAddress().then(async (_address) => {
          getTansactionByWallet("sepolia", _address).then((_response) => {
            setallTransaction(_response);
            setLoading(false);
          });
        });
      

        getAddress().then(async (_response) => {
          //---BEP------//
          TokenBalancebyWallet(
            "sepolia",
            _response,
            "0x776820f1a6adbED4B790EA58a01Af2d5F7E02967"
          ).then((_bepBalance) => {
            
            setercTokenBalance(_bepBalance);
          });
        });
      }

      getAddress().then((_response) => {
        getWalletBalances(_response);
      });
    }
  }, [chain, signer, isConnected]);

  //------------get-current-user-address----------------------//

  async function getAddress() {
    const address = await signer.getAddress();
    return address;
  }

  //-----------------------get wallet balance-----------------------------//

  const getWalletBalances = async (address) => {
    getWallwtChainBalance("bsc%20testnet", address).then((_balance) => {
      setBscBalance(_balance);
    });

    getWallwtChainBalance("sepolia", address).then((_balance) => {
      setSepoliabalance(_balance);
      setEtherBalance(_balance);
    });
    return 0;
  };
  //  console.log("Pricessssss",pricing)
  return (
    <div className="p-8">
      {/*   
      <h1 className="lg:text-center px-12 ">THE FUNDS WILL TRANSFER IN</h1>
      <div class="flex lg:justify-center space-x-2 px-14 lg:px-0 ">
        <div class="p-2">
          <div id="days" class=" lg:text-center  lg:text-6xl text-3xl">
            {" "}
            05{" "}
          </div>
          <div class="lg:text-center">Day</div>
        </div>
        <div class=" p-2">
          <div id="hours" class="lg:text-center lg:text-6xl text-3xl">
            18{" "}
          </div>
          <div class="lg:text-center">Hrs</div>
        </div>
        <div class="p-2">
          <div id="minutes" class=" lg:text-center lg:text-6xl text-3xl">
            {" "}
            43{" "}
          </div>
          <div class=" lg:text-center ">Min</div>
        </div>
        <div class=" p-2">
          <div id="seconds" class=" lg:text-center lg:text-6xl text-3xl">
            02{" "}
          </div>
          <div class=" lg:text-center">Sec</div>
        </div>
      </div> */}

      <div className=" grid grid-cols-1 lg:grid-cols-3 gap-4 pt-8  ">
        <div className=" flex gap-8 bg-white rounded-xl border text-left shadow-md lg:p-8 p-4 w-auto  mt-4 lg:mt-0 ml-4 lg:ml-0">
          {/* BITCOIN */}
          <div>
            <p className="text-blue-400 mb-4">BNB</p>
            <h1 className=" text-2xl  text-gray-700">{bscBalance}</h1>
            <h3 className="font-semibold mt-2 text-sm text-gray-400">
              BNB/USD
            </h3>
          </div>
          <div className="flex items-center mb-4">
            <center className="mt-8">
              <SiBinance size={50} color="yellow" />
            </center>
          </div>
        </div>

        <div className=" flex gap-8 bg-white rounded-xl border text-left  shadow-md lg:p-8 p-4 w-auto  mt-4 lg:mt-0 ml-4 lg:ml-0">
          {/* ETHEREUM */}
          <div>
            <p className="text-blue-400 mb-4">ETHEREUM</p>
            <h1 className=" text-2xl  text-gray-700"> {sepoliabalance}</h1>
            <h3 className="font-semibold mt-2 text-sm text-gray-400">
              ETC/USD
            </h3>
          </div>
          <div className="flex items-center mb-4">
            <center className="mt-8">
              <SiEthereum size={50} color="blue" />
            </center>
          </div>
        </div>

        {/* <div className=" flex gap-8 bg-white rounded-xl border text-left  shadow-md lg:p-8 p-4 w-auto  mt-4 lg:mt-0 ml-4 lg:ml-0">
          <div>
            <p className="text-blue-400 mb-4">USD</p>
            <h1 className=" text-2xl  text-gray-700">0</h1>
            <h3 className="font-semibold mt-2 text-sm text-gray-400">USD</h3>
          </div>
          <div className="flex items-center mb-4">
            <center className="mt-8">
              <MdMonetizationOn size={50} color="green" />
            </center>
          </div>
        </div> */}

        <div className=" flex gap-8 bg-white rounded-xl border text-left  shadow-md lg:p-8 p-4 w-auto  mt-4 lg:mt-0 ml-4 lg:ml-0">
          {/* Dio */}
          <div>
            <p className="text-blue-400 mb-4">Dio</p>
            <h1 className=" text-2xl  text-gray-700">{ercTokenBalance}</h1>
            <h3 className="font-semibold mt-2 text-sm text-gray-400">
              DIO/USD
            </h3>
          </div>
          <div className="flex items-center mb-4">
            <center className="mt-8">
              <FaJediOrder size={50} color="purple" />
            </center>
          </div>
        </div>

        <div className="pt-8 ">
          <h1 className=" text-blue-400 text-center lg:text-left">
            Your Portfolio
          </h1>
    {
      balanceloading?(<Spinner/>):(
        <BalanceCard
      Ethbalance={etherBalance}
      bscBalance={bscBalance}
      dioBalance={ercTokenBalance}
      EthUsd = {pricing[0].EthUsd}
      BnbUsd ={pricing[0].BnbUsd}
    />
      )
    }
        </div>
        <div className=" pt-8 lg:col-span-2 ">
          <h1 className=" text-blue-400 text-center lg:text-left">
            Recent Transactions
          </h1>
          {loading ? (
            <div className=" "><Spinner/></div>
          ) : (
            allTransaction.map((data) => {
              const formattedDate = dateFormat(data.date, "mmmm - dS");

              localStorage.setItem("currentChain", currentChain);

              return (
                <RecentTCard
                  toAddress={data.toAddress}
                  fromAddress={data.fromAddress}
                  date={formattedDate}
                  hash={data.hash}
                  currenChain={currentChain}
                />
              );
            })
          )}
        </div>
        <div className="pt-8 lg:col-span-3">
          {balanceloading? (null):(
            <Marquee
             Ethbalance={etherBalance}
            bscBalance={bscBalance}
            dioBalance={ercTokenBalance}
            EthUsd = {pricing[0].EthUsd}
      BnbUsd ={pricing[0].BnbUsd}
           />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
